import React from 'react';
import { Label } from 'bootstrap';
import { Icon } from '@shoflo-rundown/polymer.legacy';
import classnames from 'classnames';

export default React.createClass({
  displayName: 'Label',

  propTypes: {
    color: React.PropTypes.string,
    text: React.PropTypes.string,
    classes: React.PropTypes.array,
    onRemove: React.PropTypes.func,
    removeIcon: React.PropTypes.string,
    key: React.PropTypes.string,
  },

  getDefaultProps() {
    return {
      removeIcon: 'times-circle',
    };
  },

  render() {
    const { color, text, classes, id, onRemove, removeIcon } = this.props;

    return (
      <Label
        className={classnames(classes)}
        style={{ background: color, color: this._getTxtColor(color) }}
        key={this.props.key}
      >
        <Icon style={{ color: this._getTxtColor(color) }} name="tag" />
        <span
          style={{ color: this._getTxtColor(color) }}
          className="label-text"
        >
          {text}
        </span>
        {onRemove ? (
          <Icon
            style={{ color: this._getTxtColor(color) }}
            name={removeIcon}
            onClick={() => onRemove(id)}
          />
        ) : null}
      </Label>
    );
  },

  _getTxtColor(hexColor) {
    if (!hexColor) return;

    hexColor = hexColor.replace(/^#+/i, '');

    let r = parseInt(hexColor.substr(0, 2), 16),
      g = parseInt(hexColor.substr(2, 2), 16),
      b = parseInt(hexColor.substr(4, 2), 16);

    let colorSpace = (r * 299 + g * 587 + b * 114) / 1000;

    return colorSpace >= 128 ? 'black' : 'white';
  },
});
